import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseZnCurriculumUnitConvert } from '@/api/responses/znCurriculumUnits'

export namespace ZnCurriculumUnitsApi {
  /**
   * 増進堂単元から日能研単元情報を取得する
   *
   * @param id 増進堂単元ID
   * @returns 指定した増進堂単元情報と、それに紐づく日能研単元情報
   */
  export async function getZnCurriculumUnitConvert(id: number): Promise<ApiResponseZnCurriculumUnitConvert> {
    return await ApiBase.get(`/znCurriculumUnits/${id}/convert`)
  }
}
